// A cierre client's logo (its wordmark), as `listCierreClients` serves it — a signed URL that expires.
// Used by the shell's client selector and by the panels' title (`TituloCierres`).
import { useState } from "react";
import { cn } from "@mantis-sas/ui";

// The client's own logo in place of its name. The logo is the client's wordmark, so the name beside
// it would say the same thing twice; it stays as the `alt`. A URL that fails to load shows
// `children` — the name — instead, never a broken image; callers key it by `src`, so a new URL gets
// a fresh try. On the dark theme the logo sits on a white chip: these wordmarks are drawn for a
// light page.
export function LogoCliente({ src, nombre, className, children }) {
  const [fallo, setFallo] = useState(false);

  if (!src || fallo) return children;
  return (
    <span className="inline-flex min-w-0 shrink items-center dark:rounded-[4px] dark:bg-white dark:px-1 dark:py-0.5">
      <img src={src} alt={nombre} onError={() => setFallo(true)} className={cn("w-auto object-contain", className)} />
    </span>
  );
}
